/** Peak filter options — parity with Ai-Tempo Enum_RecordHistory.ts */

export const RECORD_POWER_PEAK_OPTIONS = [
  {id: 'powermax', fa_name: 'ماکزیمم'},
  {id: 'power5sec', fa_name: '5 ثانیه'},
  {id: 'power10sec', fa_name: '10 ثانیه'},
  {id: 'power12sec', fa_name: '12 ثانیه'},
  {id: 'power20sec', fa_name: '20 ثانیه'},
  {id: 'power30sec', fa_name: '30 ثانیه'},
  {id: 'power1min', fa_name: '1 دقیقه'},
  {id: 'power2min', fa_name: '2 دقیقه'},
  {id: 'power5min', fa_name: '5 دقیقه'},
  {id: 'power6min', fa_name: '6 دقیقه'},
  {id: 'power10min', fa_name: '10 دقیقه'},
  {id: 'power12min', fa_name: '12 دقیقه'},
  {id: 'power20min', fa_name: '20 دقیقه'},
  {id: 'power30min', fa_name: '30 دقیقه'},
  {id: 'power60min', fa_name: '1 ساعت'},
  {id: 'power90min', fa_name: '90 دقیقه'},
  {id: 'power180min', fa_name: '3 ساعت'},
] as const;

export const RECORD_HEART_RATE_PEAK_OPTIONS = [
  {id: 'heart_ratemax', fa_name: 'ماکزیمم'},
  {id: 'heart_rate5sec', fa_name: '5 ثانیه'},
  {id: 'heart_rate10sec', fa_name: '10 ثانیه'},
  {id: 'heart_rate12sec', fa_name: '12 ثانیه'},
  {id: 'heart_rate20sec', fa_name: '20 ثانیه'},
  {id: 'heart_rate30sec', fa_name: '30 ثانیه'},
  {id: 'heart_rate1min', fa_name: '1 دقیقه'},
  {id: 'heart_rate2min', fa_name: '2 دقیقه'},
  {id: 'heart_rate5min', fa_name: '5 دقیقه'},
  {id: 'heart_rate6min', fa_name: '6 دقیقه'},
  {id: 'heart_rate10min', fa_name: '10 دقیقه'},
  {id: 'heart_rate12min', fa_name: '12 دقیقه'},
  {id: 'heart_rate20min', fa_name: '20 دقیقه'},
  {id: 'heart_rate30min', fa_name: '30 دقیقه'},
  {id: 'heart_rate60min', fa_name: '1 ساعت'},
  {id: 'heart_rate90min', fa_name: '90 دقیقه'},
  {id: 'heart_rate180min', fa_name: '3 ساعت'},
] as const;

/** Pace peaks (sec/km) — derived from speed on import; lower is better. */
export const RECORD_PACE_PEAK_OPTIONS = [
  {id: 'pacemax', fa_name: 'ماکزیمم'},
  {id: 'pace5sec', fa_name: '5 ثانیه'},
  {id: 'pace10sec', fa_name: '10 ثانیه'},
  {id: 'pace12sec', fa_name: '12 ثانیه'},
  {id: 'pace20sec', fa_name: '20 ثانیه'},
  {id: 'pace30sec', fa_name: '30 ثانیه'},
  {id: 'pace1min', fa_name: '1 دقیقه'},
  {id: 'pace2min', fa_name: '2 دقیقه'},
  {id: 'pace5min', fa_name: '5 دقیقه'},
  {id: 'pace6min', fa_name: '6 دقیقه'},
  {id: 'pace10min', fa_name: '10 دقیقه'},
  {id: 'pace12min', fa_name: '12 دقیقه'},
  {id: 'pace20min', fa_name: '20 دقیقه'},
  {id: 'pace30min', fa_name: '30 دقیقه'},
  {id: 'pace60min', fa_name: '1 ساعت'},
  {id: 'pace90min', fa_name: '90 دقیقه'},
  {id: 'pace180min', fa_name: '3 ساعت'},
] as const;

export const COACH_TREND_HEART_RATE_PEAK_OPTIONS = [
  { id: 'heart_rate5sec', fa_name: '5 ثانیه' },
  { id: 'heart_rate1min', fa_name: '1 دقیقه' },
  { id: 'heart_rate5min', fa_name: '5 دقیقه' },
  { id: 'heart_rate20min', fa_name: '20 دقیقه' },
  { id: 'heart_rate60min', fa_name: '60 دقیقه' },
] as const;

export const COACH_TREND_POWER_PEAK_OPTIONS = [
  { id: 'power5sec', fa_name: '5 ثانیه' },
  { id: 'power10sec', fa_name: '10 ثانیه' },
  { id: 'power20sec', fa_name: '20 ثانیه' },
  { id: 'power30sec', fa_name: '30 ثانیه' },
  { id: 'power1min', fa_name: '1 دقیقه' },
  { id: 'power5min', fa_name: '5 دقیقه' },
  { id: 'power10min', fa_name: '10 دقیقه' },
  { id: 'power20min', fa_name: '20 دقیقه' },
  { id: 'power30min', fa_name: '30 دقیقه' },
  { id: 'power60min', fa_name: '60 دقیقه' },
] as const;

export const COACH_TREND_PACE_PEAK_OPTIONS = [
  { id: 'pace5sec', fa_name: '5 ثانیه' },
  { id: 'pace1min', fa_name: '1 دقیقه' },
  { id: 'pace5min', fa_name: '5 دقیقه' },
  { id: 'pace10min', fa_name: '10 دقیقه' },
  { id: 'pace20min', fa_name: '20 دقیقه' },
  { id: 'pace60min', fa_name: '60 دقیقه' },
] as const;

export const RECORD_YEAR_OPTIONS = (() => {
  const currentYear = new Date().getFullYear();
  const years: { id: string; fa_name: string; value: number | null }[] = [
    { id: 'all', fa_name: 'همه', value: null },
  ];
  for (let y = currentYear; y >= currentYear - 4; y--) {
    years.push({ id: String(y), fa_name: String(y), value: y });
  }
  return years;
})();

export type PeakCategory = 'power' | 'heart_rate' | 'pace';
export type RecordMetricType = 'value' | 'wkg';
export type RecordRangeId =
  | 'd7'
  | 'd14'
  | 'd30'
  | 'd90'
  | 'd180'
  | '12m'
  | 'all'
  | 'custom'
  | `y${number}`;

const RECORD_DAY_RANGE_IDS = ['d7', 'd14', 'd30', 'd90', 'd180'] as const;

function isoDateDaysAgo(days: number): string {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - days);
  return start.toISOString().slice(0, 10);
}

export const RECORD_RANGE_OPTIONS: {
  id: RecordRangeId;
  labelKey: string;
  fallback: string;
  groupKey?: string;
}[] = (() => {
  const currentYear = new Date().getFullYear();
  const recentGroup = 'coach.peakTrends.rangeGroupRecent';
  const dayRanges: { id: RecordRangeId; labelKey: string; fallback: string }[] = [
    { id: 'd7', labelKey: 'coach.peakTrends.range7d', fallback: '7 days' },
    { id: 'd14', labelKey: 'coach.peakTrends.range14d', fallback: '14 days' },
    { id: 'd30', labelKey: 'coach.peakTrends.range30d', fallback: '30 days' },
    { id: 'd90', labelKey: 'coach.peakTrends.range90d', fallback: '90 days' },
    { id: 'd180', labelKey: 'coach.peakTrends.range180d', fallback: '180 days' },
  ];
  const options: {
    id: RecordRangeId;
    labelKey: string;
    fallback: string;
    groupKey?: string;
  }[] = [
    ...dayRanges.map((opt, i) => ({
      ...opt,
      groupKey: i === 0 ? recentGroup : undefined,
    })),
    {
      id: '12m',
      labelKey: 'coach.peakTrends.range12m',
      fallback: 'Last 12 months',
      groupKey: 'coach.peakTrends.rangeGroupOther',
    },
    { id: 'all', labelKey: 'coach.peakTrends.rangeAll', fallback: 'All time' },
    { id: 'custom', labelKey: 'coach.peakTrends.rangeCustom', fallback: 'Custom' },
  ];
  for (let y = currentYear; y >= currentYear - 4; y--) {
    options.push({
      id: `y${y}`,
      labelKey: '',
      fallback: String(y),
      groupKey: y === currentYear ? 'coach.peakTrends.rangeGroupYears' : undefined,
    });
  }
  return options;
})();

export function defaultCustomDateRange(): { start: string; end: string } {
  const end = new Date();
  const start = new Date(end);
  start.setMonth(start.getMonth() - 12);
  return {
    start: start.toISOString().slice(0, 10),
    end: end.toISOString().slice(0, 10),
  };
}

export function resolveRecordHistoryParams(
  rangeId: RecordRangeId,
  peakType: string,
  sportId: string,
  metricType: RecordMetricType,
  customRange?: { start: string; end: string },
): Record<string, string | number | boolean> {
  const params: Record<string, string | number | boolean> = {
    peak_type: peakType,
    best_only: 1,
    limit: 15,
  };

  if (metricType === 'wkg' && peakType.toLowerCase().startsWith('power')) {
    params.metric_type = 'wkg';
  }

  if (rangeId === 'all') {
    params.all_time = 1;
  } else if (rangeId === 'custom') {
    if (customRange?.start && customRange?.end) {
      params.start_date = customRange.start;
      params.end_date = customRange.end;
    }
  } else if (rangeId === '12m') {
    const end = new Date();
    const start = new Date(end);
    start.setMonth(start.getMonth() - 12);
    params.start_date = start.toISOString().slice(0, 10);
    params.end_date = end.toISOString().slice(0, 10);
  } else if ((RECORD_DAY_RANGE_IDS as readonly string[]).includes(rangeId)) {
    const days = Number(rangeId.slice(1));
    params.start_date = isoDateDaysAgo(days);
    params.end_date = new Date().toISOString().slice(0, 10);
  } else if (rangeId.startsWith('y')) {
    const year = Number(rangeId.slice(1));
    params.start_date = `${year}-01-01`;
    params.end_date = `${year}-12-31`;
  }

  if (sportId !== 'all') {
    params.workout_type_id = Number(sportId);
  }

  return params;
}

export function isPacePeakType(peakType: string): boolean {
  return peakType.toLowerCase().startsWith('pace');
}

export function peakOptionsForCategory(category: PeakCategory) {
  if (category === 'heart_rate') return RECORD_HEART_RATE_PEAK_OPTIONS;
  if (category === 'pace') return RECORD_PACE_PEAK_OPTIONS;
  return RECORD_POWER_PEAK_OPTIONS;
}

export function coachTrendPeakOptionsForCategory(category: PeakCategory) {
  if (category === 'heart_rate') return COACH_TREND_HEART_RATE_PEAK_OPTIONS;
  if (category === 'pace') return COACH_TREND_PACE_PEAK_OPTIONS;
  return COACH_TREND_POWER_PEAK_OPTIONS;
}

/** Default interval when switching category — power trends open at the standard 20-minute effort. */
export function defaultCoachTrendPeakType(category: PeakCategory): string {
  if (category === 'power') return 'power20min';
  return coachTrendPeakOptionsForCategory(category)[0]?.id ?? 'power5min';
}
